import React, { useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./Pages/Home";
import Programming from "./Pages/Programming";
import Youtube from "./Pages/Youtube";
import Hosting from "./Pages/Hosting";
import Learning from "./Pages/Learning";
import Community from "./Pages/Community";
import Ide from "./Pages/IDE";
import ScrollArraw from "./components/Button/ScrollArrow";
import { Route, Switch, useLocation } from "react-router-dom";
import Javascript from "./Pages/Programming/Language/javascript";
import Typescript from "./Pages/Programming/Language/typescript";
import Java from "./Pages/Programming/Language/java";
import Php from "./Pages/Programming/Language/php";
import Python from "./Pages/Programming/Language/python";
import ReactF from "./Pages/Programming/Framework/react";
import Angular from "./Pages/Programming/Framework/angular";
import Vue from "./Pages/Programming/Framework/vue";
import Banniere from "./components/Banniere";
import { AnimatePresence } from "framer-motion";
import Job from "./Pages/Job";
import Challenge from "./Pages/Challenge";
import ScrollToTop from "./components/Scroll/ScrollToTop";
import Design from "./Pages/Design";

const App = () => {
  // Animer la transition entre pages
  const location = useLocation();
  // Ouvrir et fermer le menu (hamburger)
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  const closeSidebar = () => setSidebar(false);

  return (
    <div className="base">
      <Header sidebar={sidebar} showSidebar={showSidebar} />
      <Banniere />
      <div
        onClick={closeSidebar}
        className={sidebar ? "content blur" : "content"}
      >
        <ScrollToTop />
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route exact path="/" component={Home} />
            <Route exact path="/programming" component={Programming} />
            <Route exact path="/youtube-channel" component={Youtube} />
            <Route exact path="/hosting" component={Hosting} />
            <Route exact path="/learning" component={Learning} />
            <Route exact path="/community" component={Community} />
            <Route exact path="/ide" component={Ide} />{" "}
            <Route exact path="/challenge" component={Challenge} />
            <Route exact path="/job" component={Job} />
            <Route exact path="/design" component={Design} />
            <Route
              exact
              path="/programming/javascript"
              component={Javascript}
            />
            <Route
              exact
              path="/programming/typescript"
              component={Typescript}
            />
            <Route exact path="/programming/java" component={Java} />
            <Route exact path="/programming/php" component={Php} />
            <Route exact path="/programming/python" component={Python} />
            <Route exact path="/programming/react" component={ReactF} />
            <Route exact path="/programming/angular" component={Angular} />
            <Route exact path="/programming/vue" component={Vue} />
          </Switch>
        </AnimatePresence>
      </div>
      <ScrollArraw />
      <Footer />
    </div>
  );
};

export default App;
